import { N, round, ceil } from './helpers.mjs';

export const KITCHEN = [
  // ====================== KITCHEN FITTERS ======================
  {
    slug: 'kitchen-worktop',
    trade: 'kitchen-fitters',
    name: 'Worktop Lengths',
    blurb: 'Std worktop 3m × 600mm. Add 100mm joins.',
    inputs: [
      { key: 'length', label: 'Total run', unit: 'm', placeholder: '5.4' },
      { key: 'piece', label: 'Length per piece', unit: 'm', placeholder: '3', default: 3 },
    ],
    compute: (v) => {
      const pieces = ceil(N(v.length) / (N(v.piece) || 3));
      return [
        { label: 'Worktop pieces', value: pieces, unit: 'pcs' },
        { label: 'Joining strips', value: Math.max(pieces - 1, 0), unit: 'pcs' },
      ];
    },
  },
  {
    slug: 'kitchen-units',
    trade: 'kitchen-fitters',
    name: 'Kitchen Units Estimator',
    blurb: 'Plan base + wall + tall units.',
    inputs: [
      { key: 'run', label: 'Base unit run', unit: 'm', placeholder: '4' },
      { key: 'wallRun', label: 'Wall unit run', unit: 'm', placeholder: '3' },
      { key: 'unitW', label: 'Average unit width', unit: 'mm', placeholder: '600', default: 600 },
    ],
    compute: (v) => {
      const w = (N(v.unitW) || 600) / 1000;
      return [
        { label: 'Base units', value: ceil(N(v.run) / w), unit: 'pcs' },
        { label: 'Wall units', value: ceil(N(v.wallRun) / w), unit: 'pcs' },
        { label: 'Plinth length', value: round(N(v.run), 2), unit: 'm' },
        { label: 'Cornice length', value: round(N(v.wallRun), 2), unit: 'm' },
      ];
    },
  },

];
